import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.566 5.242a.84.84 0 0 1 .766-.492h3.309c.328 0 .629.191.765.492l.219.383h2.625a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875H6.75a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875h2.625zM17.25 8.25l-.602 9.27c-.027.71-.601 1.23-1.312 1.23h-6.7c-.71 0-1.284-.52-1.312-1.23L6.75 8.25z"
    }, null, -1)
  ]))]))
}
export default { render: render }